import { createSelector } from 'reselect';

const selectFinancialYears = (state: any) => state.financialYears;

export const selectFinancialYearsCurrentItem = createSelector([selectFinancialYears], (financialYears) => financialYears.current);

export const selectFinancialYearsListItems = createSelector([selectFinancialYears], (financialYears) => financialYears.list);

export const selectFinancialYearsItemById = (itemId: any) =>
    createSelector(selectFinancialYearsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectFinancialYearsQueryItems = createSelector([selectFinancialYears], (financialYears) => financialYears.query);

export const selectFinancialYearsCreatedItem = createSelector([selectFinancialYears], (financialYears) => financialYears.create);

export const selectFinancialYearsUpdatedItem = createSelector([selectFinancialYears], (financialYears) => financialYears.update);

export const selectFinancialYearsReadItem = createSelector([selectFinancialYears], (financialYears) => financialYears.read);

export const selectFinancialYearsDeletedItem = createSelector([selectFinancialYears], (financialYears) => financialYears.delete);

export const selectFinancialYearsSearchedItems = createSelector([selectFinancialYears], (financialYears) => financialYears.search);

export const selectFinancialYearsItemsCount = createSelector([selectFinancialYears], (financialYears) => financialYears.count);

export const selectFinancialYearsItemsFilter = createSelector([selectFinancialYears], (financialYears) => financialYears.filter);